export default {
  recommendations: "Recommendations",
  search: "Search...",
  searchError: "User not found",
  continue: "Continue",
  exit: "Go out",
  follow: "Follow",
  unfollow: "Unfollow",
  download: "Download mobile app",
  postNotFound: "Post not found",
  justNow: "just now",
  feed: {
    lenta: "Lenta",
    type: {
      title: "Feed type",
      default: "Default",
      short: "Short",
    },
    feedEmpty: "To see the posts, subscribe to someone.",
    error: "An error occurred when uploading posts. Please try again later.",
    remakes: {
      title: "Remakes",
      description: "All remakes made will be displayed here.",
    },
  },
  menu: {
    home: "Home",
    profile: "Profile",
  },
  qr: {
    title: "COMIXON Mobile App",
    description: "Point your device camera at the QR code",
  },
  comments: {
    title: "Comments",
    notFound: "No comments found",
    empty: "This comment is empty.",
    longError:
      "Your comment is too long. The maximum length is 1024 characters.",
    filter: {
      new: "New",
      author: "Author",
      my: "My",
    },
    input: "Enter a comment",
    active: {
      answer: "Answer",
      remove: "Remove",
      report: "Report",
    },
    delete: {
      title: "Confirm Deletion",
      description: "Are you sure you want to delete this comment?",
      confirm: "Confirm",
      close: "Close",
    },
  },
  report: {
    title: "Report",
    category: {},
    send: "Send Report",
    error: "Failed to send report. Please try again later.",
  },
  profile: {
    followers: "Followers",
    following: "Following",
    edit: "Edit profile",
    strip: "Strips",
    emptyProfile: "The user's strips will be here",
  },
  profileEdit: {
    title: "Profile Editing",
    bg: "Change background",
    colorTitle: "Color selection",
    bubbleType: "Bubble type",
    formPlaceholder: {
      name: "Name",
      nickname: "Nickname",
    },
    settings: {
      title: "Profile Settings",
      description: "Change personal account information",
      error: "Incorrectly entered fields: ",
      inputs: {
        number: { label: "Phone number", placeholder: "Add a phone number" },
        email: { label: "Email", placeholder: "Add email" },
        social: {
          label: "Social link",
          placeholder: "Add a link to social networks",
        },
        date: { label: "Date of birth", placeholder: "Add date of birth" },
        city: { label: "City", placeholder: "Add a city" },
        region: { label: "Region" },
      },
    },
    button: "Save changes",
    save: "Save",
  },
  login: {
    profile: "Log in",
    title: "Login an account",
    description: "Enter the phone number you provided during registration",
    bottom:
      "By clicking 'Continue', you accept the user agreement and privacy policy.",
    error: "Error: ",
    validateError: "Validation error. ",
    incorrectPhone: "Incorrect phone number",
    phoneEmpty: "Enter your phone number",
    authError: "Authorization error: ",
  },
  verification: {
    title: "Verification code",
    placeholder: "Enter code",
    description:
      "Enter the last 4 digits of the number from which the call will be made",
    code: "The code can be sent again in:",
    codeSms: "Get code via sms",
    bottom:
      "By clicking 'Confirm', you accept the user agreement and privacy policy.",
  },
  notification: {
    copy: "Link copied to clipboard!",
    complain: "The complaint has been sent",
    openApp: "Open the App Store in the app",
    open: "Open",
  },
};
